/**
 * @generated SignedSource<<509b68fa77ddadec52cafbef5d19f06d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MusicPieceStatus = "COMPLETE" | "ERRORED" | "PROCESSING" | "UPLOADING" | "%future added value";
export type PollPlayStepsQuery$variables = {
  piece_id: string;
};
export type PollPlayStepsQuery$data = {
  readonly music_viewer: {
    readonly piece: {
      readonly id: string;
      readonly status: MusicPieceStatus;
    };
  };
};
export type PollPlayStepsQuery = {
  variables: PollPlayStepsQuery$variables;
  response: PollPlayStepsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "piece_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MusicViewer",
    "kind": "LinkedField",
    "name": "music_viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "piece_id"
          }
        ],
        "concreteType": "MusicPiece",
        "kind": "LinkedField",
        "name": "piece",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PollPlayStepsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PollPlayStepsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "948e4cd5616aaad80c94f98b15cc9a3f",
    "id": null,
    "metadata": {},
    "name": "PollPlayStepsQuery",
    "operationKind": "query",
    "text": "query PollPlayStepsQuery(\n  $piece_id: ID!\n) {\n  music_viewer {\n    piece(id: $piece_id) {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea60ff34e604bb0757552632d9930566";

export default node;
